/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import React from "react";
import { Row, DefaultCellTypes } from "@silevis/reactgrid";

import { BulkItem } from "./types";
import { ImageCell } from "../../GenericGrid/template/ImageCellTemplate";
import { DataRowConfig } from "../../GenericGrid/types";
import { createErrorKey } from "../../GenericGrid/utils";
import TextCellRenderer from "./TextCellRenderer";

const createTextCell = (value: string | undefined, errorKey: string, errors: Record<string, string>): DefaultCellTypes => ({
  type: "text" as const,
  text: value || '',
  renderer: (cellText: string) => <TextCellRenderer text={cellText} error={errors[errorKey]} />
});

export const getBulkItemRow = ({ data, headerRow, errors }: DataRowConfig<BulkItem>): Row<DefaultCellTypes | ImageCell>[] => [
  headerRow,
  ...data.map<Row<DefaultCellTypes | ImageCell>>((item, idx) => ({
    rowId: idx,
    cells: [
      createTextCell(item.categoryName, createErrorKey(idx, "categoryName"), errors),
      createTextCell(item.itemName, createErrorKey(idx, "itemName"), errors),
      createTextCell(item.price, createErrorKey(idx, "price"), errors),
      createTextCell(item.availableStatus, createErrorKey(idx, "availableStatus"), errors),
      createTextCell(item.section, createErrorKey(idx, "section"), errors),
      createTextCell(item.description, createErrorKey(idx, "description"), errors),
      createTextCell(item.photo1, createErrorKey(idx, "photo1"), errors),
      createTextCell(item.photo2, createErrorKey(idx, "photo2"), errors),
      createTextCell(item.photo3, createErrorKey(idx, "photo3"), errors), 
      createTextCell(item.photo4, createErrorKey(idx, "photo4"), errors),
      createTextCell(item.optionGroup1, createErrorKey(idx, "optionGroup1"), errors),
      createTextCell(item.optionGroup2, createErrorKey(idx, "optionGroup2"), errors),
    ],
  })),
];
